module.exports = __webpack_public_path__ + "static/media/HorizontalBar_CS.52d94cd1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/reports/assets/HorizontalBar_CS.svg
// module id = 281
// module chunks = 0